module.exports = __webpack_public_path__ + "media/images/smart_phone/portal/icon_orange2-45e4b2af33bba560bc74fd4376fb534c.png";